import React from 'react';

import { Link, Tabs, Text } from '@betterment/samba-react';

import { urlBuilder } from '../../Shared/urlBuilder';

const TabNavigation: React.FC = () => {
  return (
    <Tabs defaultValue="tabAvailableRewards">
      <Tabs.List>
        <Tabs.Trigger value="tabAvailableRewards">
          <Text>Available Rewards</Text>
        </Tabs.Trigger>
        <Tabs.Trigger value="tabLinkToEarnedRewards" css={{ px: 'space.0', py: 'space.0', display: 'grid' }}>
          <Link
            href={urlBuilder.appEarnedRewards.absolute()}
            css={{
              color: 'text',
              _hover: { textDecoration: 'none' },
              height: '100%',
              width: '100%',
              display: 'grid',
              placeContent: 'center',
            }}
          >
            <Text>Earned Rewards</Text>
          </Link>
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="tabAvailableRewards" />
    </Tabs>
  );
};

export default TabNavigation;
